/** @jsx jsx */
import { jsx, Box, Styled } from "theme-ui"
import { graphql, useStaticQuery } from "gatsby"
import { alpha } from "@theme-ui/color"
import BackgroundImage from "gatsby-background-image"

import { Container, Row, Col } from "components/layout"

const SupportingEachotherHeroOne = () => {
  const data = useStaticQuery(graphql`
    query {
      hero: file(relativePath: { eq: "supporting-eachother-1.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 1920) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)

  return (
    <Box sx={{ mt: -4 }}>
      <BackgroundImage
        tag="div"
        fluid={data.hero.childImageSharp.fluid}
        backgroundColor="#fff"
        sx={{
          backgroundSize: "cover",
          backgroundPosition: ["center", "center right"],
        }}
      >
        <Box
          sx={{
            backgroundColor: [
              alpha("secondary", 0.9),
              alpha("secondary", 0.9),
              alpha("secondary", 0),
            ],
            backgroundImage: [
              "none",
              "linear-gradient(to right, rgba(0,0,0,0.95) 0%, rgba(0,0,0,0.95) 40%, rgba(0,0,0,0) 65%)",
            ],
            color: "background",
            py: 4,
            width: "100%",
          }}
        >
          <Container wide>
            <Row>
              <Col sx={{ width: ["100%", "70%", "50%"] }}>
                <Styled.h1 sx={{ color: "background" }}>
                  Dear type 1, you can’t stop us
                </Styled.h1>
                <Styled.p>Dear type 1,</Styled.p>
                <Styled.p>
                  It’s been nearly three years since you’ve entered my life.
                  Although it hasn’t been easy, I’m learning to live with you.
                  My mother, Hélène, says I’m resilient and I suppose I am.
                  You’ve left me with no choice except to keep fighting for
                  myself and others. So that’s been my focus.
                </Styled.p>
                <Styled.p sx={{ fontWeight: "bold" }}>
                  I remember the day I was diagnosed.
                </Styled.p>
                <Styled.p>
                  It was a shock to me and an even bigger one to my family. My
                  mother still gets emotional talking about it. It started when
                  she saw I was tired and thirsty. When she hugged me, she
                  noticed I was thinner. But I was also a growing 12-year-old
                  boy, who was about to become a teenager. Like most parents,
                  mine assumed these were normal changes.
                </Styled.p>
                <Styled.p>
                  Just to be sure, my mother had a pharmacist check my blood
                  glucose levels. Before I knew what was happening, I found
                  myself at the hospital emergency department where I received
                  this life-changing diagnosis.
                </Styled.p>
              </Col>
            </Row>
          </Container>
        </Box>
      </BackgroundImage>
    </Box>
  )
}

export default SupportingEachotherHeroOne
